import Icon from '@/legacy-src/components/icons/Icon'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { ButtonLink } from '@/src/domains/design-system/components/Button'

export interface HeaderActionsProps {
  isBusiness?: boolean
}

export const HeaderActions = ({ isBusiness = false }: HeaderActionsProps) => {
  const { t } = getTranslate()

  return (
    <>
      <ButtonLink
        href="/login"
        variant={isBusiness ? 'outline' : 'yellow'}
        size="small"
        suffixIcon={isBusiness ? undefined : <Icon color="primary" icon="arrow" />}
        className="hidden whitespace-nowrap tablet:block"
      >
        {t('component.button.login')}
      </ButtonLink>
      {isBusiness ? null : (
        <ButtonLink href="/diagnosis" size="small">
          {t('components.pageBlocks.mainHeader.button')}
        </ButtonLink>
      )}
      {isBusiness ? (
        <ButtonLink
          href={t('component.navigation.requestDemoHref')}
          size="small"
          variant="yellow"
          className="whitespace-nowrap"
        >
          {t('general.requestDemo')}
        </ButtonLink>
      ) : null}
    </>
  )
}
